import { createContext, useReducer, useEffect } from 'react'
import * as Sentry from '@sentry/react'

export const UserContext = createContext()

const initialState = {
  login: localStorage.getItem('token') !== null,
  username: localStorage.getItem('username')
    ? JSON.parse(localStorage.getItem('username'))
    : null,
  showLoginPopup: false
}

const reducer = (state, action) => {
  const { type, payload } = action

  switch (type) {
    case 'success':
    case 'login':
      localStorage.setItem('token', payload.token)
      localStorage.setItem('username', JSON.stringify(payload))
      return {
        ...state,
        login: true,
        username: payload
      }
    case 'failed':
    case 'logout':
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      return {
        ...state,
        login: false,
        username: null
      }

    case 'showLoginPopup':
      return {
        ...state,
        showLoginPopup: true
      }
    case 'hideLoginPopup':
      return {
        ...state,
        showLoginPopup: false
      }
    case 'updateWarehouseActive':
      localStorage.removeItem('username')
      localStorage.setItem('username', JSON.stringify(payload))
      return {
        ...state,
        username: payload
      }
    default:
      throw new Error()
  }
}

export const UserContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  useEffect(() => {
    if (state.login && state.username) {
      Sentry.setUser({
        id: state.username.id,
        username: state.username.username
      })
    } else {
      Sentry.setUser(null)
    }
  }, [state.login, state.username])

  return (
    <UserContext.Provider value={[state, dispatch]}>
      {children}
    </UserContext.Provider>
  )
}
